import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const EOL = '\r\n';
const BOM = '\ufeff';
const CONFIG_DEFAULTS = {
  filename: 'report.csv',
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: false,
  showTitle: false,
  title: 'Report',
  useBom: true,
  headers: [],
  shouldTranslateHeaders: false,
  translationPrefix: 'csv.'
};

@Injectable()
export class CsvService {
  private csv: string;
  private data: Object[];
  private _options: any;

  constructor(private translate: TranslateService) {}

  public dataToCsv(sourceData: Object[], filename: string, options = {}) {
    this.csv = '';
    this.data = sourceData;
    this._options = { ...CONFIG_DEFAULTS, ...options };
    if (filename) {
      this._options.filename = filename;
    }
    this.generateCsv();
  }

  private generateCsv() {
    if (this._options.useBom) {
      this.csv += BOM;
    }
    if (this._options.showTitle) {
      this.csv += this._options.title + '\r\n\n';
    }
    this.setHeaders();
    this.setRows();
    if (this.csv == '') {
      console.error('Invalid data');
      return;
    }

    const blob = new Blob([this.csv], { type: 'text/csv;charset=utf8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('visibility', 'hidden');
    link.download = this._options.filename.replace(/ /g, '_') + '.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private setHeaders() {
    if (this._options.headers.length) {
      let headers = [...this._options.headers];
      if (this._options.shouldTranslateHeaders) {
        headers = headers.map((header: string) => this.translate.instant(this._options.translationPrefix + header));
      }
      this.csv += headers.join(this._options.fieldSeparator) + EOL;
    }
  }

  private setRows() {
    this.data.forEach((record) => {
      const row = this._options.headers.map((column) => {
        return this.formatCell(record[column]);
      });
      this.csv += row.join(this._options.fieldSeparator) + EOL;
    });
  }

  private formatCell(value: any) {
    if (value == null) {
      return '';
    }
    if (this._options.decimalSeparator === 'locale' && this.isFloat(value)) {
      return value.toLocaleString();
    }
    if (this._options.decimalSeparator !== '.' && this.isFloat(value)) {
      return value.toString().replace('.', this._options.decimalSeparator);
    }
    if (typeof value === 'string') {
      value = value.replace(/"/g, '""');
      if (
        this._options.quoteStrings ||
        value.indexOf(',') > -1 ||
        value.indexOf('\n') > -1 ||
        value.indexOf('\r') > -1
      ) {
        value = this._options.quoteStrings + value + this._options.quoteStrings;
      }
      return value;
    }
    if (typeof value === 'boolean') {
      return value ? 'TRUE' : 'FALSE';
    }
    return value;
  }

  private isFloat(input) {
    return +input === input && (!isFinite(input) || Boolean(input % 1));
  }
}
